var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "225px",
    height: "196px",
    viewBox: "0 0 225 196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-1--Introduction",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.4--login---first-login---plan-selection---thank-you-page",
    transform: "translate(-608.000000, -267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(609.000000, 268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.504202,122.289823 C215.504202,65.1073673 169.358428,18.75 112.436975,18.75 C55.5155221,18.75 9.3697479,65.1073673 9.3697479,122.289823 C9.3697479,137.525708 12.6730525,151.977279 18.5530378,165 L206.320912,165 C212.200897,151.977279 215.504202,137.525708 215.504202,122.289823",
    id: "Fill-1",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.361345, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0341691,37.6734755 C50.3181681,38.67731 49.7357905,39.7207221 48.7328068,40.004962 L8.78601478,51.3403758 C7.78303108,51.6246157 6.74050321,51.0417441 6.45650424,50.0397086 L0.0719197737,27.5020059 C-0.212079197,26.4981715 0.370298439,25.4547593 1.37328215,25.1705194 L41.3200741,13.8351056 C42.3230578,13.5508657 43.3655857,14.1337373 43.6495847,15.1375718 L50.0341691,37.6734755 Z",
    id: "Fill-39",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7193262,32.00325 L41.2478162,23.2799645 C38.8410147,23.9635794 36.3389479,22.5639679 35.6541149,20.156924 L9.50823495,27.5741453 C10.189473,29.9829882 8.79104768,32.4907753 6.38604373,33.1725912 L8.8557563,41.8958767 C11.2625577,41.2122618 13.7664221,42.6118733 14.4494576,45.0207162 L40.597135,37.6016959 C39.9140995,35.192853 41.3125248,32.6868649 43.7193262,32.00325",
    id: "Fill-41",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4099122,31.3523767 C30.0911502,33.7612196 28.6945224,36.2654088 26.287721,36.9490236 C23.8809196,37.6326385 21.3770552,36.233027 20.6940197,33.8259831 C20.0109842,31.4171402 21.411207,28.909353 23.816211,28.2275372 C26.2230124,27.5439223 28.7286742,28.9435338 29.4099122,31.3523767",
    id: "Fill-43",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4099122,31.3523767 C30.0911502,33.7612196 28.6945224,36.2654088 26.287721,36.9490236 C23.8809196,37.6326385 21.3770552,36.233027 20.6940197,33.8259831 C20.0109842,31.4171402 21.411207,28.909353 23.816211,28.2275372 C26.2230124,27.5439223 28.7286742,28.9435338 29.4099122,31.3523767 Z",
    id: "Stroke-45",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7193262,32.00325 L41.2478162,23.2799645 C38.8410147,23.9635794 36.3389479,22.5639679 35.6541149,20.156924 L9.50823495,27.5741453 C10.189473,29.9829882 8.79104768,32.4907753 6.38604373,33.1725912 L8.8557563,41.8958767 C11.2625577,41.2122618 13.7664221,42.6118733 14.4494576,45.0207162 L40.597135,37.6016959 C39.9140995,35.192853 41.3125248,32.6868649 43.7193262,32.00325 Z",
    id: "Stroke-47",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0341691,37.6734755 C50.3181681,38.67731 49.7357905,39.7207221 48.7328068,40.004962 L8.78601478,51.3403758 C7.78303108,51.6246157 6.74050321,51.0417441 6.45650424,50.0397086 L0.0719197737,27.5020059 C-0.212079197,26.4981715 0.370298439,25.4547593 1.37328215,25.1705194 L41.3200741,13.8351056 C42.3230578,13.5508657 43.3655857,14.1337373 43.6495847,15.1375718 L50.0341691,37.6734755 Z",
    id: "Stroke-49",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.143158,50.8154316 L132.207654,41.6603894 C130.203484,41.0865127 129.044121,38.9942914 129.619309,36.9884215 L135.024276,18.1026613 C135.597667,16.0985904 137.688115,14.9382441 139.690487,15.5121208 L171.625992,24.665364 C173.628364,25.2410397 174.787727,27.333261 174.216134,29.3373319 L168.809369,48.2230921 C168.235979,50.228962 166.145531,51.3893083 164.143158,50.8154316",
    id: "Fill-51",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#DFE4EE",
    points: "172.758393 34.422527 133.568332 23.1878564 134.815771 18.8289122 174.005831 30.0653818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.181267,37.511027 L145.068493,40.6304696",
    id: "Stroke-55",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#FFFFFF",
    points: "165.908985 41.8906596 135.429424 33.1529823 136.676863 28.794038 167.156423 37.5335144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.143158,50.8154316 L132.207654,41.6603894 C130.203484,41.0865127 129.044121,38.9942914 129.619309,36.9884215 L135.024276,18.1026613 C135.597667,16.0985904 137.688115,14.9382441 139.690487,15.5121208 L171.625992,24.665364 C173.628364,25.2410397 174.787727,27.333261 174.216134,29.3373319 L168.809369,48.2230921 C168.235979,50.228962 166.145531,51.3893083 164.143158,50.8154316 Z",
    id: "Stroke-59",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-61",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "172.758393 34.422527 133.568332 23.1878564 134.815771 18.8289122 174.005831 30.0653818"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-63",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "165.908985 41.8906596 135.429424 33.1529823 136.676863 28.794038 167.156423 37.5335144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3708668,30.222973 C79.0306438,30.222973 72.2721873,23.4569848 72.2721873,15.1114865 C72.2721873,6.76598818 79.0306438,8.32667268e-14 87.3708668,8.32667268e-14 C95.7074948,8.32667268e-14 102.467749,6.76598818 102.467749,15.1114865 C102.467749,23.4569848 95.7074948,30.222973 87.3708668,30.222973 Z",
    id: "Fill-65",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3701478,0.000179898649 C79.0317223,0.000179898649 72.2714683,6.76616807 72.2714683,15.1116664 C72.2714683,19.283516 73.9610824,23.0631867 76.6932244,25.7958471 L98.0452737,4.42568666 C95.3149291,1.6912272 91.5384618,0.000179898649 87.3701478,0.000179898649",
    id: "Fill-67",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.467749,15.1114865 C102.467749,23.4569848 95.7074948,30.222973 87.3708668,30.222973 C79.0306438,30.222973 72.2721873,23.4569848 72.2721873,15.1114865 C72.2721873,6.76598818 79.0306438,8.32667268e-14 87.3708668,8.32667268e-14 C95.7074948,8.32667268e-14 102.467749,6.76598818 102.467749,15.1114865 Z",
    id: "Stroke-69",
    stroke: "#7450C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3701478,22.6675895 L87.3701478,24.5565253",
    id: "Stroke-71",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3701478,5.66680743 L87.3701478,7.55574324",
    id: "Stroke-73",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5952982,18.889538 C83.5952982,20.9763623 85.2849123,22.6674096 87.369968,22.6674096 C89.4532263,22.6674096 91.1446379,20.9763623 91.1446379,18.889538 C91.1446379,16.8027137 89.4532263,15.1116664 87.369968,15.1116664 C85.2849123,15.1116664 83.5952982,13.4206191 83.5952982,11.3337948 C83.5952982,9.24697044 85.2849123,7.55592314 87.369968,7.55592314 C89.4532263,7.55592314 91.1446379,9.24697044 91.1446379,11.3337948",
    id: "Stroke-75",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,165 L5.62184874,165",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.378151,165 L223,165",
    id: "Stroke-7",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2436975,165 L211.756303,165",
    id: "Stroke-3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.863014,127.380282 C123.863014,130.484507 99.074444,133 68.5,133 C37.9220409,133 13.1369863,130.484507 13.1369863,127.380282 C13.1369863,124.276056 37.9220409,121.760563 68.5,121.760563 C99.074444,121.760563 123.863014,124.276056 123.863014,127.380282",
    id: "Fill-9",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,78.6760563 L136.98597,8.73831508 C136.98597,3.91298905 133.029494,0 128.147034,0 L8.83542845,0 C3.9564761,0 0,3.91298905 0,8.73831508 L0.0140300571,78.6760563 L137,78.6760563 Z",
    id: "Fill-11",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7441021,78.6760563 L97.5890411,0 L8.86853041,0 C3.97129905,0 0,3.91298905 0,8.73831508 L0.0140826207,78.6760563 L17.7441021,78.6760563 Z",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,78.6760563 L137,96.1596244 C137,100.988419 133.043119,104.901408 128.156651,104.901408 L8.83633338,104.901408 C3.95688132,104.901408 0,100.988419 0,96.1596244 L0,78.6760563 L137,78.6760563 Z",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,78.6760563 L137,96.1596244 C137,100.988419 133.043119,104.901408 128.156651,104.901408 L8.83633338,104.901408 C3.95688132,104.901408 0,100.988419 0,96.1596244 L0,78.6760563 L137,78.6760563 Z",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1917808,92.7253521 C73.1917808,95.3122066 71.095374,97.4084507 68.5,97.4084507 C65.9083496,97.4084507 63.8082192,95.3122066 63.8082192,92.7253521 C63.8082192,90.1422144 65.9083496,88.0422535 68.5,88.0422535 C71.095374,88.0422535 73.1917808,90.1422144 73.1917808,92.7253521",
    id: "Fill-19",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1917808,92.7253521 C73.1917808,95.3122066 71.095374,97.4084507 68.5,97.4084507 C65.9083496,97.4084507 63.8082192,95.3122066 63.8082192,92.7253521 C63.8082192,90.1422144 65.9083496,88.0422535 68.5,88.0422535 C71.095374,88.0422535 73.1917808,90.1422144 73.1917808,92.7253521 Z",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "90.0821918 123.633803 45.0410959 123.633803 47.2931507 106.774648 87.830137 106.774648"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-25",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "90.0821918 123.633803 45.0410959 123.633803 47.2931507 106.774648 87.830137 106.774648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9041096,123.633803 L103.219178,123.633803",
    id: "Stroke-27",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,78.6760563 L136.98597,8.73831508 C136.98597,3.91298905 133.029494,0 128.147034,0 L8.83542845,0 C3.9564761,0 0,3.91298905 0,8.73831508 L0.0140300571,78.6760563 L137,78.6760563 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(46.917808, 18.732394)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#7450C8",
    cx: 20.6438356,
    cy: 20.6056338,
    rx: 20.6438356,
    ry: 20.6056338
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.27104,22.8980356 L13.9081428,19.4291208 C13.410047,18.8291538 12.6279624,18.5678167 11.8834362,18.752556 C11.1389099,18.9372953 10.5576,19.5369314 10.3785067,20.3049294 C10.1994135,21.0729273 10.4527635,21.8796676 11.0343942,22.3934662 L15.8239752,27.3550655 C16.2086067,27.7486013 16.7293018,27.9679844 17.27104,27.9647535 C17.8057201,27.9624312 18.3181023,27.7434666 18.6977237,27.3550655 L28.8883214,16.8432025 C29.2741632,16.4484472 29.4911937,15.9110895 29.4911937,15.350518 C29.4911937,14.7899466 29.2741632,14.2525888 28.8883214,13.8578335 C28.0933784,13.042694 26.8095158,13.042694 26.0145728,13.8578335 L17.27104,22.8980356 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanks);
export default __webpack_public_path__ + "static/media/thanks.9deeede14c91d983ee516b85debf4f7d.svg";
export { ForwardRef as ReactComponent };